/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-organ-at-risk.reducer';

export const TreatmentOrganAtRiskDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentOrganAtRiskEntity = useAppSelector(state => state.treatmentOrganAtRisk.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentOrganAtRiskDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentOrganAtRisk.detail.title">TreatmentOrganAtRisk</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentOrganAtRisk.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentOrganAtRiskEntity.id}</dd>
          <dt>
            <span id="exposureDose">
              <Translate contentKey="tinyMedicRestApp.treatmentOrganAtRisk.exposureDose">Exposure Dose</Translate>
            </span>
          </dt>
          <dd>{treatmentOrganAtRiskEntity.exposureDose}</dd>
          <dt>
            <span id="exposureDoseUnit">
              <Translate contentKey="tinyMedicRestApp.treatmentOrganAtRisk.exposureDoseUnit">Exposure Dose Unit</Translate>
            </span>
          </dt>
          <dd>{treatmentOrganAtRiskEntity.exposureDoseUnit}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentOrganAtRisk.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentOrganAtRiskEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentOrganAtRisk.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentOrganAtRiskEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentOrganAtRisk.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentOrganAtRiskEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentOrganAtRisk.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentOrganAtRiskEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentOrganAtRisk.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentOrganAtRiskEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentOrganAtRisk.organ">Organ</Translate>
          </dt>
          <dd>{treatmentOrganAtRiskEntity.organ ? treatmentOrganAtRiskEntity.organ.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentOrganAtRisk.radiationSession">Radiation Session</Translate>
          </dt>
          <dd>{treatmentOrganAtRiskEntity.radiationSession ? treatmentOrganAtRiskEntity.radiationSession.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-organ-at-risk" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-organ-at-risk/${treatmentOrganAtRiskEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentOrganAtRiskDetail;
